export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ескі құпиясөз"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жаңа құпиясөз"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Құпиясөзді растау"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сақтау"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Жаңа құпиясөз\" және \"Құпиясөзді растау\" сәйкес емес."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Құпиясөзді өзгерту"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4-тен 63 символға дейінгі жол. Латын алфавитінің әріптері, цифрлар және таңбалар рұқсат етілген"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бос"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Әлсіз"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Орташа"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күшті"])}
  }
}